/* eslint-disable react-hooks/exhaustive-deps */
import Shortcode from "src/libs/useful/shortcode"
import { ILanding, ILandingSection } from "../../../data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useEffect, useMemo } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { MENU_ITEM_ICON_DIVIDER } from "src/libs/basic-view/ExtendMenu"
import getTypographyStyle from "../../utils/getTypographyStyle"

/* Protopia Ecosystem component */
export interface IDescriptionProps {
   section: ILandingSection
}
const Description = ({ section, ...props }: IDescriptionProps): JSX.Element => { 
    const isEdit                    = useLandingConsoleStore((state:ILandingConsoleStore) => state.isEdit)  
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding)
    const { description, }          = currentLanding 
    const titleData                 = useMemo(() => ({ ...description, ...section.description }), [ description, section.description ])    
    const {position}                = usePosition( titleData ) 
    const typography                = {...description.typography,  ...section.description?.typography}
    useEffect(() => { 
        addCSSClass(
            `section-description-${section.id}`,
            `.section-description-${section.id} {
               ${ getTypographyStyle( typography ) } 
            }
            `
        )        
        return () => {
            removeCSSClass(`section-description-${section.id}`)
        }
    }, [ description, section.description ] )
    return <div 
        className="w-100 flex-centered"
        context-title={
            isEdit 
                ? 
                [
                    `Change Description settings${MENU_ITEM_ICON_DIVIDER}cog${MENU_ITEM_ICON_DIVIDER}changeDescriptionSection${MENU_ITEM_ICON_DIVIDER}${section.id}`,
                    //`Transform Description`,
                    `Delete Description${MENU_ITEM_ICON_DIVIDER}trash${MENU_ITEM_ICON_DIVIDER}deleteTitle${MENU_ITEM_ICON_DIVIDER}${section.id}`
                ].join("|||")
                : 
                undefined 
            }
        >
        <Shortcode 
            className={ `landing-section-description ${isEdit ? "is-edit" : " is-not-edit"} ${description.className || ""} section-description-${section.id}` }
            content={ section.description?.text || ""}         
            style={{
                ...description?.style,
                ...section.title?.style,
                ...section.description?.style,
                ...position.style
            }}
        />
    </div>
    
}
export default Description